export type KzTranslationsType = typeof kzTranslations;

export const kzTranslations = {
  translation: {
    actions: 'Әрекеттер',
    activate: 'Белсенді ету',
    active: 'Белсенді',
    activity: 'Белсенділік',
    allSchoolClasses: 'Мектептің сыныптары',
    allSchoolGroups: 'Мектептің топтары',
    allSchoolStudents: 'Мектептің оқушылары',
    analysisBoard: 'Партияны талдау',
    answer: 'Жауап',
    assign: 'Тағайындау',
    assignment: 'Бақылау жұмысы',
    assignments: 'Бақылау жұмысы',
    assignmentsPage: {
      addAssignment: 'Бақылау жұмысын құрастыру',
      assignmentConsistOf: 'Бақылау жұмысы мыналардан тұрады:',
      callToActionCreate: 'Бақылау жұмысын құрастырыңыз',
      checkpointMessage: 'Бұл аттестациялық  бақылау жұмысы. Іске сәт! \n',
      chooseClass: 'Сыныпты таңдаңыз және біз сізге лайық тақырыптарды ұсынамыз',
      chooseGroup: 'Топты таңдаңыз және біз сізге лайық тақырыптарды ұсынамыз',
      chooseTopics: 'Тақырыптарды таңдаңыз',
      createAssignment: 'Бақылау жұмысын құрастыру',
      createdList: 'Бұл бетте сіз құрастырған барлық бақылау жұмыстары шығып тұрады',
      deadlines: 'Орындалуы тиіс мерзімін көрсетіңіз',
      editAssignment: 'Бақылау жұмысын өзгерту',
      noAssignment: 'Мұнда әлі бақылау жұмыстары жоқ',
      noTopicsForClass: 'Бұл сынып бойынша тақырып табылмады',
      noTopicsForGroup: 'Бұл топ бойынша тақырып табылмады',
      quarter: 'тоқсан үшін',
      taskHasFinished: 'Жаттығу аяқталды',
      taskNotStarted: 'Тапсырма әлі басталған жоқ',
    },
    attempt: 'Талпыныс',
    attempts: 'Талпыныстар',
    attention: 'Назар аударыңыз!',
    auth: {
      auth: 'Авторизация',
      changeEmail: 'Поштаны өзгерту',
      changePassword: 'Құпия сөзді өзгерту',
      checkEmail: 'Поштаңызды тексеріңіз!',
      confirmPassword: 'Құпиясөзді қайталаңыз',
      email: 'Электронды пошта',
      enter: 'Кіру',
      enterEmail: 'Электронды поштаны енгізіңіз',
      enterNewPassword: 'Жаңа құпиясөзді жазып, растаңыз',
      errorOldPassword: 'Ескі құпиясөз жаңасынан басқаша болуы тиіс',
      finishRegister: 'Тіркеуді аяқтау',
      forgotPassword: 'Құпиясөзді ұмытып қалдыңыз ба?',
      incorrectLogin: 'Логин немесе құпиясөз дұрыс емес',
      inviteSchoolAccepted: 'Сіз жаңа мектепке шақыруды қабылдадыңыз!',
      inviteWrongCode: 'Шақыру немесе оның жарамдылық мерзімі жарамсыз',
      login: 'Логин',
      newPassword: 'Жаңа құпиясөз',
      password: 'Құпиясөз',
      passwordMinLength: 'Кемінде 6 таңба енгізіңіз',
      pleaseCheckEmail: 'Өтінемін, поштаңызды тексеріңіз',
      recoverPassword: 'Құпиясөзді қалпына келтіру',
      resetPassword: 'Құпиясөзді ауыстыру',
      resetPasswordHelpMessage: 'Немесе бапкерге жүгініп, құпиясөзді ауыстыруын өтінуге болады.',
      resetPasswordMessage: 'Құпиясөзді ауыстыру үшін электронды поштаны жазыңыз',
      schoolNotActive: 'Мектеп белсенді емес',
      schoolNotActiveCoach:
        'Сіздің мектебіңіз Chess Class жүйесіне кіру мүмкіндігі жоқ, үйлестірушіге хабарласыңыз',
      schoolNotActiveStudent:
        'Сіздің мектебіңіз Chess Class жүйесіне кіру мүмкіндігі жоқ, мұғаліміңізге хабарласыңыз',
      schoolNotActiveSuperCoach:
        'Сіздің мектебіңіз Chess Class жүйесіне кіру мүмкіндігі жоқ, бізге {{supportEmail}} электрондық пошта арқылы хабарласыңыз',
      send: 'Жіберу',
      sendConfirmation:
        'Біз сізге құпиясөзді ауыстыруға арналған нұсқаулығы бар хабарлама жібердік',
      updatePassword: 'Құпиясөзді жаңарту',
      userInactive: 'Аталмыш электронды поштаны пайдаланушы бұғатталған',
      userNotActive: 'Пайдаланушы белсенді емес',
      welcome: 'Қош келдіңіз!',
      welcomeToChess: 'Chess <span class="text-primary">Class-қа</span><br/>қош келдіңіз!',
    },
    author: 'Автор',
    authors: 'Авторлар',
    back: 'Артқа',
    birthDate: 'Туған күні',
    boardEditorPage: {
      black: 'Қаралар',
      blacksMove: 'Қаралардың жүріс кезегі',
      boardEditor: 'Тақта редакторы',
      castling: 'Рокировка',
      clearTheBoard: 'Тақтаны тазарту',
      nextMove: 'Келесі жүріс',
      startingPosition: 'Бастапқы позиция',
      turnTheBoardOver: 'Тақтаны аудару',
      white: 'Ақтар',
      whitesMove: 'Ақтардың жүріс кезегі',
    },
    cancel: 'Бас тарту',
    cartoon: 'Мультфильм',
    chapter: 'Тақырып',
    chapter_few: 'Тақырыптар',
    chapter_many: 'Тақырыптар',
    chapter_other: 'Тақырыптар',
    chapters: 'Тақырыптар',
    chaptersPage: {
      chapterList: 'Тақырыптар тізімі',
      recommendationForCoach: 'Бапкерге арналған кеңестер!',
    },
    choose: 'Таңдаңыз',
    chooseLanguage: 'Тілді таңдаңыз',
    class: 'Сынып',
    classStudio: 'Сынып студиясы',
    classWork: 'Сынып жұмысы',
    classes: 'Сыныптар',
    classesPage: {
      activateStudentMessage:
        'Осы оқушыға жүйеге кіру үшін рұқсат бергіңіз келетініне сенімдісіз бе? {{fullName}}?',
      addClass: 'Сыныпты қосу',
      addGroup: 'Топты қосу',
      addStudent: 'Оқушыны қосу',
      assignClass: 'Сыныпты тағайындау',
      assignGroup: 'Топты тағайындау',
      backToClasses: 'Кері қарай сыныптарға',
      backToGroups: 'Кері қарай топтарға',
      classLetter: 'Сынып әріпі',
      classNumber: 'Cынып нөмірі',
      createClass: 'Сыныпты құру',
      createGroup: 'Топты құру',
      deactivateStudentMessage:
        'Осы оқушыға жүйеге кіру үшін берілген рұқсатты тоқтатқыңыз келетініне сенімдісіз бе? {{fullName}}?',
      deleteClassMessage: 'Шынымен Сыныпты жойғыңыз келе ме {{grade}} "{{symbol}}”',
      deleteGroupMessage: 'Шынымен Сыныпты жойғыңыз келе ме "{{symbol}}”',
      editClass: 'Сыныпты өзгерту',
      editCoach: 'Ұстазды өзгерту',
      editGroup: 'Топты өзгерту',
      editStudent: 'Оқушыны өңдеу',
      editTeacher: 'Мұғалімді өзгерту',
      educationLanguage: 'Оқу тілі',
      excludeFromClass: 'Сыныптан шығарып жіберу',
      excludeFromGroup: 'Топтан шығарып жіберу',
      excludeFromSchool: 'Мектептен шығарып жіберу',
      excludeStudentFromClass: '{{fullName}} сыныптан шығарып жібергіңіз келетініне сенімдісіз бе?',
      excludeStudentFromGroup: '{{fullName}} топтан шығарып жібергіңіз келетініне сенімдісіз бе?',
      excludeStudentFromSchool:
        '{{fullName}} мектептен шығарып жібергіңіз келетініне сенімдісіз бе?',
      exportPdf: 'PDF-ты жүктеу',
      groupNumber: 'Топтың нөмірі',
      loginGenerate: 'Логин  "email" бағанында түрленеді',
      myClasses: 'Менің сыныптарым',
      myGroups: 'Менің топтарым',
      myStudents: 'Менің оқушыларым',
      noGrades: 'Бағаланбаған',
      noHomework: 'Мұнда әлі үйге берілген тапсырма жоқ',
      noIndependentWork: 'Мұнда әлі берілген өзіндік жұмыстары жоқ',
      noStudents: 'Мұнда әлі оқушылар жоқ',
      resetPassword: 'Құпиясөзді қалпына келтiру',
      studentPasswordGenerate: 'Оқушының құпиясөзі “туған күні” бағанында түрленді',
      studentsCount: 'Студенттер саны',
      successActivateStudentMessage: 'Оқушы сәтті қосылды',
      successDeactivateStudentMessage: 'Оқушы сәтті шығарылды',
      successExcludeStudentFromClassMessage: 'Оқушы сыныптан сәтті шығарылды',
      successExcludeStudentFromGroupMessage: 'Оқушы топтан сәтті шығарылды',
      successExcludeStudentFromSchoolMessage: 'Оқушы мектептен сәтті шығарылды',
      tableEmptyPlaceholder:
        'Оқушылар сіздің мектебіңізге түскен кезде, осында көрініп тұратын болады',
      unassigned: 'Тағайындалмаған',
    },
    clear: 'Тазарту',
    coach: 'Ұстаз',
    coaches: 'Ұстаздар',
    content: 'Мазмұны',
    copied: 'Көшірілді',
    copy: 'Көшіру',
    correctLessonsCount: ' есеп дұрыс',
    create: 'Кұру',
    date: 'Күні',
    delete: 'Жою',
    edit: 'Өзгерту',
    email: 'Пошта',
    executionReport: 'Орындалу туралы есеп',
    exercise: 'Жаттығу',
    exerciseStatus: {
      FAILED: 'Дұрыс емес',
      HOORAYGOODANSWER: 'Ура! Бұл дұрыс жауап!',
      NA: 'Орындалмады',
      SOLVED: 'Дұрыс',
    },
    exercises: 'Жаттығулар',
    exit: 'Шығу',
    filter: 'Фильтр',
    finish: 'Аяқтау',
    finishAt: 'Аяқталу уақыты',
    finishDate: 'Орындалу мерзімі',
    fio: 'Аты-жөні',
    firstName: 'Аты',
    gender: {
      boy: 'Ұл бала',
      female: 'Әйел',
      girl: 'Қыз бала',
      male: 'Еркек',
      title: 'Жынысы',
    },
    givenDate: 'Берілді',
    goBack: 'Артқа',
    grade: 'Баға',
    grades: 'Бағалар',
    group: 'Топ',
    groupStudio: 'Топ студиясы',
    groups: 'Топтар',
    guideline: 'Әдістемелік құрал',
    guidelines: 'Әдістемелік құралдар',
    help: 'Көмек',
    helpModal: {
      haveQuestions: 'Сұрақтарыңыз бар ма?',
      helpText: 'Барлық сұрақтар бойынша бізбен пошта арқылы хабарласа аласыз',
    },
    hide: 'Жасыру',
    homeWorkIsDone: 'Өзіндік жұмыс аяқталды',
    homework: 'Үй жұмысы',
    homeworks: 'Үй жұмыстары',
    homeworksPage: {
      addHomework: 'Үй жұмысын құрастыру',
      attempts: 'Талпыныс',
      callToActionCreate: 'Үй жұмысын құрастырыңыз',
      chooseClass: 'Сыныпты таңдаңыз және біз сізге лайықты тақырыптарды ұсынамыз',
      chooseGroup: 'Топты таңдаңыз және біз сізге лайықты тақырыптарды ұсынамыз',
      chooseTopic: 'Тақырыпты таңдаңыз',
      completed: 'Орындалды',
      correctTasksCount: '{{count}} / {{total}} есеп дұрыс',
      createHomework: 'Тапсырманы дайындау',
      createdList: 'Сіз құрастырған барлық үй жұмыстары осы бетте шығып тұрады',
      currentDeadLine: 'Мерзімі',
      deadlines: 'Орындалу мерзімін көрсетіңіз',
      deadlinesEdit: 'Орындалу мерзімдерін өзгерту',
      deleteHomeworkMessage: 'Сіз “{{name}}” шынымен жойғыңыз келеді ме?',
      editDueDate: 'Орындалу мерзімін өзгерту',
      execute: 'Орындау',
      homework: 'Үй жұмыстары',
      homeworkConsistOf: 'Бақылау жұмысы мыналардан тұрады:  ',
      issued: 'Берілді',
      newDeadLine: 'Жаңа мерзім',
      noTopicsForClass: 'Аталмыш сынып бойынша тақырыптар табылмады',
      noTopicsForGroup: 'Аталмыш топ бойынша тақырыптар табылмады',
      possible: '/ {{count}} ықтимал',
      startHomeworkMessage: 'Шынымен үй тапсырмасын орындауға көшкіңіз келе ме?',
      startIndependentMessage: 'Шынымен өзіндік тапсырмасын орындауға көшкіңіз келе ме?',
      successEditDueDateChange: 'Тапсырманы орындау мерзімі сәтті өзгертілді',
      task: 'Тапсырма',
      tasks: 'Тапсырмалар',
      toAllStudents: 'Барлық студенттерге',
      usedAttemptsCount: 'Пайдаланылған талпыныстар саны',
      watchChapter: 'Тақырыпты қарау',
    },
    iin: 'ЖСН',
    independentWork: 'Өзіндік жұмыс',
    independentWorks: 'Өзіндік жұмыстар',
    invalidEmail: 'Жарамсыз электрондық пошта',
    language: {
      de: 'Немісше',
      en: 'Ағылшынша',
      fr: 'Французша',
      kz: 'Қазақша',
      ru: 'Орысша',
    },
    lastName: 'Тегі',
    lesson: 'Сабақ',
    lessons: 'Сабақтар',
    lessonsPage: {
      firstLevel: '1-й уровень',
      fourthLevel: '4-й уровень',
      secondLevel: '2-й уровень',
      thirdLevel: '3-й уровень',
      topicsMessage: 'Мұнда өткен сабақтардың тақырыптары көрініп тұрады',
      welcomeToChess: 'Салем! Chess <span class="text-primary">Class-қа</span><br/>қош келдіңіз!',
    },
    login: 'Логин',
    materials: 'Қосымша материалдар',
    messages: {
      birthDateShouldNotBeInTheFuture: 'Туған күні болашақта болмауы керек',
      chapterNotSelected: 'Тақырып таңдалмаған',
      dueDateCannotBeEarlierThanStartDate:
        'Орындалу мерзімі басталу күнінен ерте болуы мүмкін емес',
      dueDateCannotBeEarlierThanTheCurrentDate:
        'Орындалу мерзімі ағымдағы күннен ерте болуы мүмкін емес',
      error: 'Қате орын алды, әрекетті қайталаңыз',
      errorEmailAlreadyUsed: 'Бұл электрондық пошта бос емес',
      errorPostReview: 'Пікір сақталған жоқ',
      errorProfileNotFound: 'Мұндай профиль жоқ',
      errorReviewPost: 'Шолуды сақтау мүмкін болмады',
      errorUserNotFound: 'Пайдаланушы табылмады',
      studentNotSelected: 'Оқушы таңдалмаған',
      successAdminInvite: 'Қызметкерлерге шақыру жіберілді',
      successAssignmentCreate: 'Бақылау жұмысы сәтті құрастырылды',
      successAssignmentDelete: 'Бақылау жұмысы сәтті жойылды!',
      successAssignmentEdit: 'Бақылау жұмысы сәтті өзгертілді',
      successAuthorDelete: 'Автор сәтті жойылды!',
      successAuthorEdit: 'Автор сәтті өзгертілді',
      successChapterCreate: 'Тақырып сәтті құрастырылды',
      successChapterDelete: 'Тақырып сәтті жойылды!',
      successChapterEdit: 'Тақырып сәтті өзгертілді',
      successChapterGive: 'Тақырып сәтті берілді',
      successClassCreate: 'Сынып сәтті құрастырылды',
      successClassDelete: 'Сынып сәтті жойылды',
      successClassEdit: 'Сынып сәтті өзгертілді',
      successCoachDelete: 'Бапкер сәтті жойылды!',
      successCoachEdit: 'Бапкер сәтті өзгертілді',
      successExerciseDelete: 'Жаттығу сәтті жойылды!',
      successExerciseGroupDelete: 'Жаттығулар тобы жойылды',
      successExerciseGroupEdit: 'Жаттығулар тобы өзгертілді',
      successGroupCreate: 'Топ сәтті құрастырылды',
      successGroupDelete: 'Топ сәтті жойылды',
      successGroupEdit: 'Топ сәтті өзгертілді',
      successHomeworkCreate: 'Үй тапсырмасы сәтті құрастырылды',
      successHomeworkDelete: 'Үй тапсырмасы сәтті жойылды!',
      successPasswordInvoke: 'Құпия сөзді қалпына келтіру нұсқаулары поштаңызға жіберілді',
      successPasswordUpdate: 'Құпиясөз сәтті жаңартылды',
      successProfileEdit: 'Профиль сәтті жаңартылды',
      successRegister: 'Сәтті тіркелу',
      successReviewPost: 'Шолу сәтті аяқталды',
      successSchoolDelete: 'Мектеп сәтті жойылды',
      successStaffDelete: 'Қызметкерлер сәтті жойылды',
      successStaffEdit: 'Қызметкерлер сәтті өзгертілді',
      successStudentAddToClass: 'Оқушы сыныпқа сәтті қосылды',
      successStudentAddToGroup: 'Оқушы топқа сәтті қосылды',
      successStudentCreate: 'Оқушы сәтті енгізілді',
      successStudentEdit: 'Оқушы сәтті өзгертілді',
      successVideoDelete: 'Бейне сәтті жойылды',
      successVideoEdit: 'Бейне сәтті өзгертілді',
      successVideoFileDelete: 'Бейнефайл сәтті жойылды',
      successVideoFileEdit: 'Бейнефайл сәтті өзгертілді',
      successVideoFileUpload:
        'Бейнефайл сәтті жүктелді, біраз уақыттан кейін ол таңдалуға қолжетімді болады',
      warningAssignmentConsistOf: 'Бақылау жұмысында кемінде 1 тапсырма болу керек',
      warningHomeworkConsistOf: 'Үй жұмысында кемінде 1 тапсырма/тест болуы керек',
      warningSession: 'Мерзімі өткен немесе жарамсыз пішім, кейінірек қайталап көріңіз',
      warningStudentEmail: 'Бұл электрондық поштасы бар оқушы тіркелген',
    },
    middleName: 'Әкесінің аты',
    modals: {
      exerciseAttemptsTooltipDescription:
        'Талпыныстардың жалпы санын бір есепті шығару үшін пайдалануға болады немесе өзіңіздің қалауыңызға қарап, бірнеше есептерге бөліп тастай аласыз. Әр есепті тиімді  шешу үшін талпыныстарды саналы түрде пайдалануға тырысыңыз.',
      exerciseAttemptsTooltipTitle: 'Есептерді шығару үшін сізге талпыныстар берілген',
      exerciseHelpText:
        'Талпыныстың көп бөлігі пайдаланылды. Нәтижені жақсарту және тапсырманы сәтті орындаудың мүмкіндігін арттыру үшін басқа есептерге өтуге тырысып көріңіз',
      goodLuck: 'Іске сәт!',
      incorrectAnswer: 'Дұрыс емес',
      mustAnswerAllQuestions: 'Барлық сұрақтарға жауап беру керек!',
      tryAgain: 'Тағы қайталап көріңіз',
    },
    more: 'Толығырақ',
    newestFirst: 'Алдымен жаңалары',
    next: 'Келесі',
    no: 'Жоқ',
    noResult: 'Ешқандай нәтиже табылмады',
    notFoundResult: {
      chooseClass: 'Сыныпты таңдаңыз',
      chooseGroup: 'Топты таңдаңыз',
      createClass: 'Cыныпты құрастырыңыз',
      createClassHelpMessage: 'Жаңа сыныпты сыныптар қойындысында жасауға болады',
      createGroup: 'Топты құрастырыңыз',
      createGroupHelpMessage: 'Жаңа топты топтар қойындысында жасауға болады',
      goBackToAssignments: 'Барлық бақылау тапсырмалары қойындысына оралыңыз',
      goBackToHomeworks: 'Барлық үй тапсырмалары қойындысына оралыңыз',
      noAssignment: 'Бақылау жұмысы әлі берілмеген',
      noChapterExercises: 'Бұл тақырыпқа тапсырмалар әлі қосылмаған',
      noChapters: 'Тақырыптар табылмады',
      noCoach: 'Ұстаз табылмады',
      noHomework: 'Үй тапсырмасы табылмады',
      noHomeworkExercises: 'Үй тапсырмасында тапсырмалар табылмады',
      noLessons: 'Cабақтар табылмады',
      noMaterials: 'Бұл тақырыпқа қосымша материалдар әлі қосылмаған',
      noStudent: 'Оқушы табылмады',
    },
    oldestFirst: 'Алдымен ескілері',
    passed: 'Өтті',
    pause: 'Кідірту',
    phone: 'Телефон',
    phoneNumber: 'Телефон нөмірі',
    problem: 'Тапсырма',
    problem_few: 'Тапсырмалар',
    problem_many: 'Тапсырмалар',
    problem_other: 'Тапсырмалар',
    problems: 'Тапсырмалар',
    proceed: 'Кірісу',
    profile: 'Профиль',
    profilePage: {
      birthDate: 'Туған күні',
      email: 'Email',
      emailPlaceholder: 'Электронды поштаны енгізіңіз',
      firstName: 'Аты',
      gender: 'Жынысы',
      genderPlaceholder: 'Жынысын таңдаңыз',
      iin: 'ЖСН',
      lastName: 'Тегі',
      loginAndPassword: 'Логин және құпиясөз',
      loginHelpText: 'Логин  “email” бағанында түрленді',
      middleName: 'Әкесінің аты',
      passwordRepeatError: 'Бұл құпиясөз бұрын қолданылған, құпиясөзді жаңартыңыз',
      personalInfo: 'Жеке ақпарат',
      phone: 'Телефон',
      phonePlaceholder: 'Телефон нөмірін енгізіңіз',
      profileSettings: 'Профиль көрсеткіштері',
      schoolAndCoach: 'Мектеп және ұстаз',
      schoolAndTeacher: 'Мектеп және ұстаз',
      withoutCoach: 'Ұстазсыз',
      withoutCoachHelpText: 'Сіз әлі ешбір ұстазбен байланысқан жоқсыз',
      withoutTeacher: 'Ұстазсыз',
      withoutTeacherHelpText: 'Сіз әлі бірде-бір ұстазға бекітілмегенсіз',
    },
    profileSettings: 'Профиль көрсеткіштері',
    report: 'Есеп',
    requiredField: 'Бұл керек аймақ',
    result: 'Нәтиже',
    results: 'Нәтижелер',
    review: {
      review: 'Бағалау',
      reviewChapter: 'Бұл тақырыпты бағалауыңызды өтінеміз',
      reviewExercise: 'Бұл тапсырманы бағалауыңызды өтінеміз',
      reviewLesson: 'Бұл сабақты бағалауыңызды өтінеміз',
      reviewTest: 'Сіз жаңа ғана орындаған өзіндік жұмыстың сұрақтарын бағалаңыз',
      reviewVideo: 'Қараған бейнені бағалауңызды өтінеміз',
      tellUsMoreDetails: 'Толығырақ айтып беріңіз',
      thisWillHelpUpToImprove: 'бұл оны жақсартуымызға көмектеседі',
      whatDidYouLike: 'Сізге нақты не ұнағанын айтып беріңіз',
      whatYouDidntLike: 'Сізге не ұнамағанын айтып беріңіз',
    },
    save: 'Сақтау',
    school: 'Мектеп',
    schools: 'Мектептер',
    search: 'Іздеу',
    searchHelpText: 'Іздеуді өзгертуге тырысып көріңіз',
    seeDetails: 'Өту',
    selfWorkIsDone: 'Үй жұмысы аяқталды',
    show: 'Көрсету',
    solution: 'Шешім',
    solvedCount: 'Орындалды',
    sortByColumnAsc: 'sortByColumnAsc',
    sortByColumnDesc: 'sortByColumnDesc',
    sortedByColumnAsc: 'sortedByColumnAsc',
    sortedByColumnDesc: 'sortedByColumnDesc',
    startAt: 'Берілген уақыты',
    startDate: 'Басталу уақыты',
    status: 'Мәртебе',
    statuses: {
      ACTIVE: 'Белсенді',
      ALL: 'Все',
      AVAILABLE: 'Қолжетімді',
      DELETED: 'Жойылды',
      DISABLED: 'Бұғатталған',
      DRAFT: 'Шимай дәптер',
      FAILED: 'Дұрыс емес',
      FINISHED: 'Аяқталды',
      GIVEN: 'Берілген',
      INACTIVE: 'Тоқтатылған',
      INVITED: 'Шақырту жіберілді',
      ISSUED: 'Берілді',
      NA: 'Орындалмады',
      NEW: 'Жаңа',
      NOT_AVAILABLE: 'Қолжетімcіз',
      NOT_INVITED: 'Шақырту жіберілмеді',
      NOT_ISSUED: 'Берілмеген',
      NOT_PASSED: 'Өткен жоқ',
      PASSED: 'Өтті',
      PAUSED: 'Тоқтатылған',
      SOLVED: 'Дұрыс',
    },
    student: 'Оқушы',
    studentDetails: 'Оқушының мәліметтері',
    studentProfile: 'Оқушының профилі',
    student_few: 'Оқушы',
    student_many: 'Оқушы',
    student_other: 'Оқушылар',
    students: 'Оқушылар',
    studio: 'Студия',
    studiosPage: {
      alertEndLesson: 'Сабақты аяқтағыңыз келетініне сенімдісіз бе?',
      attemptsLeft: 'Талпыныстар қалды',
      available: 'Қолжетімді',
      chooseAnswer: 'Жауапты таңдаңыз',
      chooseClass: 'Сыныпты таңдаңыз',
      chooseGroup: 'Топты таңдаңыз',
      demonstrationsStudio: 'Демонстрациялық студиясы',
      endLesson: 'Сабақты аяқтау',
      findTheBestMoveFor: 'Ең жақсы жүрісті табыңыз',
      findTheBestMoveForBlack: 'Қаралар үшін ең жақсы жүрісті табыңыз',
      findTheBestMoveForWhite: 'Ақтар үшін ең жақсы жүрісті табыңыз',
      giveHomeWork: 'Үйге тапсырмасын беру',
      given: 'Берілген',
      hideAnswer: 'Жауапты жасыру',
      hideSolution: 'Шешімді жасыру',
      showAnswer: 'Жауабын көрсету',
      showSolution: 'Шешімді көрсету',
      studioView: 'Сынып студиясының көрсетілімі',
      viewMoves: 'Қозғалыстарды қарау',
      weWillSuggest: 'Біз сізге қолайлы тақырыптар мен тапсырмаларды ұсынамыз',
      yourMove: 'Сіздің жүрісіңіз',
    },
    successPasswordResetMessage: 'Құпиясөз сәтті ауыстырылды',
    superCoach: 'Үйлестіруші',
    superCoaches: 'Үйлестірушілер',
    teacher: 'Ұстаз',
    teachers: 'Ұстаздар',
    test: 'Тест',
    tests: 'Тесттер',
    time: 'Уақыт',
    title: 'Аты',
    total: 'Барлығы',
    tryAgainLater: 'Кейінірік тағы қайталап көріңіз',
    type: 'Түрі',
    understand: 'Түсінікті',
    videofiles: 'Бейнефайлдар',
    videolesson: 'Бейнесабақ',
    yes: 'Иә',
    youHaveMoreAttempts: 'Сіздің талпыныстарыңыз бар, қайта оралып, нәтижелерді жақсарта аласыз',
    yourResult: 'Сіздің нәтижеңіз',
  },
};
